export class Menu {

    constructor(domElm) {
        this.domElm = domElm;

        // Get menu elements
        this.burgerMenu = this.domElm.querySelector(".burger-menu-button");
        this.menuElments = this.domElm.querySelectorAll(".menu-item-has-children > :first-child");

        this.addListeners();
        this.handleScroll();
        this.exposeHeaderHeight();
    }

    /**
     * Expose la hauteur réelle du header en CSS via --header-h.
     * Utilisé par les éléments sticky (landings) pour se figer pile sous le header
     * sans scroller légèrement avant.
     */
    exposeHeaderHeight() {
        const set = () => {
            document.documentElement.style.setProperty(
                "--header-h",
                `${this.domElm.offsetHeight}px`
            );
        };

        set();
        window.addEventListener("resize", set);
        window.addEventListener("load", set);
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(set);
        }
    }


    addListeners() {
        // this.domElm.querySelector(".burger-menu-button");
        this.burgerMenu.addEventListener("click", () => {
            this.domElm.classList.toggle("open");
            document.body.classList.toggle("no-scroll");
        })

        this.menuElments.forEach((elm) => {
            elm.addEventListener("click", (ev) => {
                ev.preventDefault();

                elm.classList.toggle("open");
            })
        })
    }

    handleScroll() {
        window.addEventListener("scroll", () => {
            this.domElm.classList.toggle("scrolled", window.scrollY > 0);
        });
    }
}
